export const openSliderDialogAction = () => ({
  type: 'OPEN_SLIDER_DIALOG'
});

export const closeSliderDialogAction = () => ({
  type: 'CLOSE_SLIDER_DIALOG'
});

export const addContentAction = (content) => ({
  type: 'ADD_CONTENT',
  payload: content
});

export const addFabAction = (fab) => ({
  type: 'ADD_FAB',
  payload: fab
});
